// =========================

// File: src/components/ChatSkeleton.jsx

// =========================

import React from "react";

import "./chatSkeleton.css";
import { imsLoader } from "../../../assets";



const SkeletonBubble = ({ isUser }) => {

    return (

        <div className={`row ${isUser ? "row-user" : "row-bot"}`}>

            <div className={`bubble ${isUser ? "bubble-user" : "bubble-bot"}`}>
                <div className="line line-long" />
                <div className="line line-short" />
            </div>
        </div>

    );

};



export default function ChatSkeleton() {

    return (
        <div className="container">
            {[...Array(2)].map((_, i) => (
                <SkeletonBubble key={i} isUser={i % 2 === 0} />
            ))}
            <div><img src={imsLoader} alt="" width={50} /></div>
        </div>
    );

}





// =========================

// File: src/components/chatSkeleton.css

// =========================
